$bog_vmap_app_publish $mol_view
	store $bog_vmap_app_publish_store
	part \
	source \
	js \
	css \
	doc \
	classes /string
	lib_link \
	foreign false
	sub <= content /$mol_view
	Publish $mol_button_minor
		title \В библиотеку
		hint <= publish_hint \
		enabled <= enabled false
		click? <=> publish? null
	Copy $mol_button_copy
		hint \Скопировать ссылку библиотеки для поля палитры другой сцены
		text <= lib_link
		title <= lib_link
	Note $mol_view
		sub / <= note \
